import { connect } from 'react-redux';
import { MapWrapper } from './MapWrapper';
import {
  getSelectedServiceList,
  getSelectedServiceOrder,
} from '../../redux/modules/serviceOrders/serviceOrderSelectors';
import { getActiveObject } from '../../redux/modules/map/mapSelectors';
import { IRootState } from '../../redux/state';
import { ICompanySettings } from '../../models';
import { bindActionCreators, Dispatch } from 'redux';
import genericMapActions from '../../redux/modules/genericMap/genericMapActions';
import { isDataFetching } from '../../utils/GeneralUtils';
import genericMapConstants from '../../redux/modules/genericMap/genericMapConstants';

function mapStateToProps(state: IRootState) {
  return {
    selectedOrder: state.order.selected,
    selectedRouteStop: state.orderDetails.selectedRouteStop,
    vehicles: state.vehicleTracking.vehicles,
    location: state.router.location,
    selectedServiceList: getSelectedServiceList(state),
    selectedServiceOrder: getSelectedServiceOrder(state),
    activeObject: getActiveObject(state),
    token: state.geodatatoken.token,
    drawings: state.genericMapRoutes.genericMapDrawnShapes,
    genericMapLayers: state.genericMapRoutes.genericMapLayers,
    isWarningBannerHidden: state.genericMapRoutes.isWarningBannerHidden,
    isAgreementsVisible: state.genericMapRoutes.isAgreementsVisible,
    isMapDataLoading: isDataFetching(
      state,
      genericMapConstants.GET_GENERIC_MAP_DATA,
    ),
    companySettings:
      state.settings.companySettings?.find(
        (settings: ICompanySettings) =>
          settings.companyId === Number(state.authentication.customerId),
      ) || null,
    importedRouteStops: state.route.importedRouteStops,
  };
}

function mapDispatchToProps(dispatch: Dispatch) {
  return {
    genericMapActions: bindActionCreators(genericMapActions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps, null, {
  withRef: true,
})(MapWrapper);
